(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-builder"] && !Shopify.designMode) return;
  try {
    
if (!window.__NF_COMPARE_BUILDER__) {
  window.__NF_COMPARE_BUILDER__ = true;

  (function() {
    var root   = document.querySelector('[data-nf-cmp]');
    if (!root) return;

    var tray   = root.querySelector('[data-cmp-tray]');
    var clearBtn = root.querySelector('[data-cmp-clear]');
    var countEl  = root.querySelector('[data-cmp-count]');
    var hintEl   = root.querySelector('[data-cmp-hint]');
    var table    = document.getElementById('nf-cmp-table');

    var dataEl = document.getElementById('nf-cmp-data');
    var DATA = [];
    try { DATA = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch(e) { DATA = []; }

    var picked = []; // até 4
    var MAX = 4;

    function normalize(s){ return (s||'').toString().toLowerCase().trim(); }
    function matches(p, q){
      var t = normalize(p.title);
      var d = normalize(p.desc);
      return t.indexOf(q) !== -1 || (d && d.indexOf(q) !== -1);
    }

    function updateCount(){
      var n = picked.filter(Boolean).length;
      countEl.textContent = n;
      clearBtn.disabled = n === 0;
      hintEl.hidden = n >= 2;
      table.hidden = !(n >= 2);
    }

    function slotHTML(item, i){
      var empty = !item;
      var thumb = item && item.image ? '<div class="nf-cmp__slot-thumb"><img src="'+item.image+'" alt="'+item.title+'" loading="lazy"></div>' : '';
      var name = item ? item.title : 'Clique para escolher';
      var price = item ? (item.price || '') : '';
      var cta = item ? '<a class="nf-cmp__slot-cta" href="'+item.url+'" aria-label="Abrir página de '+item.title+'">Shop Now</a>' : '';
      var editBtn = item ? '<button class="nf-cmp__slot-edit" title="Trocar produto" aria-label="Trocar produto" data-slot-edit>✎</button>' : '';

      return ''+
      '<div class="nf-cmp__slot '+(empty?'is-empty':'')+'" data-slot="'+i+'">'+
        '<button class="nf-cmp__slot-open" aria-label="'+(empty?'Escolher produto':'Trocar produto')+'"></button>'+
        (item ? '<button class="nf-cmp__slot-remove" data-handle="'+item.handle+'" aria-label="Remover '+item.title+'">&times;</button>' : '')+
        (editBtn || '')+
        (thumb || '')+
        '<div class="nf-cmp__slot-meta">'+
          '<div class="nf-cmp__slot-name">'+name+'</div>'+
          (price ? '<div class="nf-cmp__slot-price">'+price+'</div>' : '')+
          cta +
        '</div>'+
        '<div class="nf-cmp__picker" hidden>'+
          '<div class="nf-cmp__picker-inner">'+
            '<input type="search" class="nf-cmp__picker-input" placeholder="Buscar produto (mín. 2 letras)" aria-label="Buscar produto">'+
            '<div class="nf-cmp__picker-help">Digite pelo menos 2 letras…</div>'+
            '<ul class="nf-cmp__picker-list" role="listbox" aria-label="Resultados da busca"></ul>'+
          '</div>'+
        '</div>'+
      '</div>';
    }

    function renderTray(){
      var html = '';
      for (var i=0; i<MAX; i++){ html += slotHTML(picked[i], i); }
      tray.innerHTML = html;

      var openBtns = tray.querySelectorAll('.nf-cmp__slot.is-empty .nf-cmp__slot-open');
      Array.prototype.forEach.call(openBtns, function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var slot = btn.closest('.nf-cmp__slot');
          togglePicker(slot, true);
        });
      });

      var editBtns = tray.querySelectorAll('[data-slot-edit]');
      Array.prototype.forEach.call(editBtns, function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var slot = btn.closest('.nf-cmp__slot');
          togglePicker(slot, true);
        });
      });

      var removes = tray.querySelectorAll('.nf-cmp__slot-remove');
      Array.prototype.forEach.call(removes, function(btn){
        btn.addEventListener('click', function(){
          var handle = btn.getAttribute('data-handle');
          for (var i=0;i<picked.length;i++){
            if (picked[i] && picked[i].handle === handle){ picked[i] = null; }
          }
          updateCount(); renderTray(); renderTable();
        });
      });

      var pickers = tray.querySelectorAll('.nf-cmp__picker');
      Array.prototype.forEach.call(pickers, function(picker){
        var input = picker.querySelector('.nf-cmp__picker-input');
        var list  = picker.querySelector('.nf-cmp__picker-list');
        var help  = picker.querySelector('.nf-cmp__picker-help');
        var slot  = picker.closest('.nf-cmp__slot');
        var slotIndex = parseInt(slot.getAttribute('data-slot'), 10);

        var tId;
        function doSearch(){
          var q = normalize(input.value);
          clearTimeout(tId);
          tId = setTimeout(function(){
            if (q.length < 2){
              help.hidden = false;
              list.innerHTML = '';
              return;
            }
            var results = DATA.filter(function(p){ return matches(p, q); });

            var chosen = {};
            picked.forEach(function(p, idx){
              if (idx !== slotIndex && p) chosen[p.handle] = true;
            });
            results = results.filter(function(p){ return !chosen[p.handle]; });

            help.hidden = results.length > 0;

            list.innerHTML = results.map(function(p){
              var img = p.image ? '<img src="'+p.image+'" alt="'+p.title+'" loading="lazy">' : '';
              return ''+
                '<li class="nf-cmp__pick-item" role="option" data-handle="'+p.handle+'">'+
                  '<div class="nf-cmp__pick-thumb">'+img+'</div>'+
                  '<div class="nf-cmp__pick-text">'+
                    '<div class="nf-cmp__pick-title">'+p.title+'</div>'+
                    (p.price ? '<div class="nf-cmp__pick-price">'+p.price+'</div>' : '')+
                  '</div>'+
                '</li>';
            }).join('');

            var items = list.querySelectorAll('.nf-cmp__pick-item');
            Array.prototype.forEach.call(items, function(li){
              li.addEventListener('click', function(){
                var handle = li.getAttribute('data-handle');
                var p = DATA.find(function(x){ return x.handle === handle; });
                picked[slotIndex] = p;

                var seenHandles = {};
                var cleaned = [];
                for (var i=0;i<picked.length;i++){
                  var it = picked[i];
                  if (!it) { cleaned[i] = it; continue; }
                  if (seenHandles[it.handle]) { cleaned[i] = null; continue; }
                  seenHandles[it.handle] = true;
                  cleaned[i] = it;
                }
                picked = cleaned;

                updateCount();
                renderTray();
                renderTable();
              });
            });
          }, 150);
        }

        input.addEventListener('input', doSearch);
        input.addEventListener('keydown', function(ev){
          if (ev.key === 'Escape'){ togglePicker(slot, false); }
        });
      });

      document.addEventListener('click', onDocClick);
    }

    function onDocClick(ev){
      var picker = ev.target.closest('.nf-cmp__picker');
      var openBtn = ev.target.closest('.nf-cmp__slot-open, [data-slot-edit]');
      if (picker || openBtn) return;
      closeAllPickers();
    }

    function closeAllPickers(){
      var pickers = tray.querySelectorAll('.nf-cmp__picker[hidden="false"], .nf-cmp__picker:not([hidden])');
      Array.prototype.forEach.call(pickers, function(p){ p.hidden = true; });
      document.removeEventListener('click', onDocClick);
    }

    function togglePicker(slotEl, open){
      closeAllPickers();
      var picker = slotEl.querySelector('.nf-cmp__picker');
      if (!picker) return;
      picker.hidden = !open ? true : false;

      if (!picker.hidden){
        var input = picker.querySelector('.nf-cmp__picker-input');
        if (input){ input.value=''; input.focus(); }
        var list  = picker.querySelector('.nf-cmp__picker-list');
        var help  = picker.querySelector('.nf-cmp__picker-help');
        if (list) list.innerHTML = '';
        if (help) help.hidden = false;
      }
    }

    function renderTable(){
      if (picked.filter(Boolean).length < 2){ table.innerHTML=''; return; }

      var comp = picked.filter(Boolean);

      var rows = [
        { label:'Produto', render:function(p){ return '<a href="'+p.url+'" class="nf-cmp__cell-product"><img src="'+(p.image||'')+'" alt="'+p.title+'" loading="lazy"/><span>'+p.title+'</span></a>'; } },
        { label:'Preço', render:function(p){ return p.price || ''; } },
        { label:'Descrição curta', render:function(p){ return p.desc || ''; } },
        { label:'Recomendado para', render:function(p){ return p.recomendado || ''; } },
        { label:'Tamanho do cachorro', render:function(p){ return p.tamanho || ''; } },
        { label:'Dureza', render:function(p){ return p.dureza || ''; } },
        { label:'Tamanho do produto', render:function(p){ return p.tamanho_produto || ''; } },
        { label:'Life stage', render:function(p){ return p.life_stage || ''; } },
        { label:'Ações', render:function(p){ return '<button class="nf-cmp__remove" data-handle="'+p.handle+'">Remover</button>'; } }
      ];

      var html = ''
        + '<div class="nf-cmp-row nf-cmp-row--head">'
        +   '<div class="nf-cmp-cell nf-cmp-cell--label">Atributo</div>'
        +   comp.map(function(p){ return '<div class="nf-cmp-cell nf-cmp-cell--head">'+p.title+'</div>'; }).join('')
        + '</div>';

      rows.forEach(function(r){
        html += '<div class="nf-cmp-row">'
          + '<div class="nf-cmp-cell nf-cmp-cell--label">'+r.label+'</div>'
          + comp.map(function(p){ return '<div class="nf-cmp-cell">'+(r.render(p)||'')+'</div>'; }).join('')
          + '</div>';
      });

      table.innerHTML = html;

      var removeBtns = table.querySelectorAll('.nf-cmp__remove');
      Array.prototype.forEach.call(removeBtns, function(btn){
        btn.addEventListener('click', function(){
          var handle = btn.getAttribute('data-handle');
          for (var i=0;i<picked.length;i++){
            if (picked[i] && picked[i].handle === handle){ picked[i] = null; }
          }
          updateCount(); renderTray(); renderTable();
        });
      });
    }

    function clearSelection(){
      picked = [];
      updateCount(); renderTray(); renderTable();
    }

    if (clearBtn) clearBtn.addEventListener('click', clearSelection);

    updateCount();
    renderTray();
  })();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
